import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import FrameTool from './FrameTool.vue'
import { CoordFormat } from '@/utils/coord_format';

@Component
export class CoordIndicatorModule extends Mixins(ModuleBase) {
  coordFormat = CoordFormat.SEXADECIMAL

  get outlet() {
    return {
      frameTool: FrameTool,
    }
  }
}
